import { db } from '../lib/db';
import bcrypt from 'bcryptjs';

export const userService = {
  getUserById: async (userId) => {
    try {
      console.log(`[userService] Fetching user with ID: ${userId}`);
      const result = await db.execute({
        sql: 'SELECT id, name, email, role FROM users WHERE id = ?',
        args: [userId]
      });
      console.log('[userService] getUserById result:', result.rows);
      if (result.rows.length > 0) {
        return result.rows[0];
      }
      return null;
    } catch (error) {
      console.error('[userService] Error fetching user by ID:', error);
      throw new Error('Failed to fetch user data.');
    }
  },

  updateUser: async (userId, userData) => {
    try {
      console.log(`[userService] Attempting to update user ID: ${userId} with data:`, userData);

      let updateFields = [];
      let updateArgs = [];

      if (userData.name) {
        updateFields.push('name = ?');
        updateArgs.push(userData.name);
      }
      if (userData.email) {
        updateFields.push('email = ?');
        updateArgs.push(userData.email);
      }
      if (userData.newPassword) {
        console.log('[userService] Hashing new password...');
        const hashedPassword = await bcrypt.hash(userData.newPassword, 10);
        console.log('[userService] Generated Bcrypt Hash (first 10 chars):', hashedPassword.substring(0, 10) + '...');
        updateFields.push('hashed_password = ?');
        updateArgs.push(hashedPassword);
      }

      if (updateFields.length === 0) {
        console.warn('[userService] No fields to update.');
        throw new Error('No fields to update.');
      }

      const sqlQuery = `UPDATE users SET ${updateFields.join(', ')} WHERE id = ?`;
      updateArgs.push(userId);

      console.log('[userService] SQL Query to execute:', sqlQuery);
      console.log('[userService] SQL Arguments:', updateArgs);

      const updateResult = await db.execute({
        sql: sqlQuery,
        args: updateArgs
      });

      console.log('[userService] DB Update result:', updateResult);
      if (updateResult.rowsAffected === 0) {
        console.warn(`[userService] No rows affected for user ID: ${userId}. User might not exist or data is identical.`);
      }

      const updatedUser = await userService.getUserById(userId);
      console.log('[userService] User after update and re-fetch:', updatedUser);
      return updatedUser;

    } catch (error) {
      console.error('[userService] Error updating user:', error);
      throw new Error('Failed to update user data.');
    }
  }
};